import React from 'react';
import styles from '../../../../HoldingsTable/HoldingsTable.module.scss';
import Box from '@material-ui/core/Box';
import ArrowDropDownSharpIcon from '@material-ui/icons/ArrowDropDownSharp';
import ArrowDropUpSharpIcon from '@material-ui/icons/ArrowDropUpSharp';
import { CircularProgress } from '@material-ui/core';

const DocumentsTableToggler = ({ showTable, setShowTable, count = 0 }) => {
  const toggleTableHandler = () => {
    setShowTable(!showTable);
  };

  return (
    <Box className={showTable ? styles.openTable : styles.closeTable}>
      <div
        className={[styles.header, showTable ? styles.open : styles.close].join(
          ' '
        )}
      >
        <span className={styles.headerLabel}>
          {count > 1 ? 'Megtekinthető verziók:' : 'Megtekinthető verzió:'}
        </span>
        <span className={styles.headerValue}>
          ( {count ?? <CircularProgress color={'inherit'} size={15} />} )
        </span>
        <span className={styles.headerStatusIcon}>
          {showTable ? (
            <ArrowDropUpSharpIcon onClick={toggleTableHandler} />
          ) : (
            <ArrowDropDownSharpIcon onClick={toggleTableHandler} />
          )}
        </span>
      </div>
    </Box>
  );
};

export default DocumentsTableToggler;
